import { Link } from '@remix-run/react'
import { Stack } from '~/components-v2/stack/stack'

export const flashActive = true
export const FlashContent = () => (
  <Stack row gap={2} align="center">
    <strong>
      🎟️ Register for our LinkedIn Live:{' '}
      <Link
        to="https://www.linkedin.com/events/aiforbiwithoutthebs-omniliveft-7338258611044798464/theater/"
        target="_blank"
        rel="noopener noreferrer"
      >
        AI for BI without the BS
      </Link>{' '}
    </strong>
  </Stack>
)
